import type { RaceConfig } from '@/core/types';
import { ehime2026Theme } from './theme';

export const raceConfig: RaceConfig = {
  id: '', // Firestoreから取得
  alias: 'ehime2026',
  name: '第63回愛媛マラソン',
  year: 2026,
  theme: ehime2026Theme,
  verification: {
    adapter: 'bib-email-birthday',
  },
  mint: {
    chain: 'soneium',
    contractAddress: '',
  },
};
